module.exports = __webpack_public_path__ + "img/hall.9d1c8491.png";